module.exports = __webpack_public_path__ + "img/gd.c15511a1.svg";